export default class TimeoutError {
    readonly message = 'Search too long, try to make more strict search';
    constructor () {
        Error.apply(this, []);
    }
}
